import React, { useMemo } from 'react'
import DashboardBox from '../../components/DashboardBox'
import FlexBetween from '../../components/FlexBetween'
import BoxHeader from '../../components/BoxHeader'
import {
  Tooltip,
  CartesianGrid,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Line,
  PieChart,
  Pie,
  Cell,
  ScatterChart,
  Scatter,
  ZAxis,
} from "recharts";
import { Box, Typography, useTheme } from "@mui/material";



const Row2 = (props) => {
  const { palette } = useTheme();
  const pieColors = [palette.red[900], palette.blue[900]];
  const operationalData = props.expenses_data.expenses_data;
  const productData = props.expenses_data.product_data;
  console.log(productData)
  const productExpenseData = useMemo(() => {
    return (
      productData &&
      productData.map(({ id, price, expense }) => {
        // Convert price and expense to numbers
        const priceValue = parseFloat(price.replace("$", ""));
        const expenseValue = parseFloat(expense.replace("$", ""));
        
        return {
          id: id,
          price: priceValue,
          expense: expenseValue,
        };
      })
    );
  }, [productData]);
  
  console.log(productExpenseData)
  console.log(operationalData);

  const operationalExpenses = useMemo(() => {
    return (
      operationalData &&
      operationalData.map(({ name, operational_expenses, non_operational_expenses }) => {
        return {
          name: name.substring(0, 3),
          "Operational Expenses": operational_expenses,
          "Non Operational Expenses": non_operational_expenses,
        };
      })
    );
  }, [operationalData]);
  console.log(operationalExpenses)
  const pieData = useMemo(() => {
    if (!operationalExpenses) return [];

    // Calculate the sum of Operational Expenses and Non Operational Expenses
    const sumOperationalExpenses = operationalExpenses.reduce((acc, item) => {
      return acc + item["Operational Expenses"];
    }, 0);

    const sumNonOperationalExpenses = operationalExpenses.reduce((acc, item) => {
      return acc + item["Non Operational Expenses"];
    }, 0);

    return [
      { name: "Operational Expenses", value: sumOperationalExpenses },
      { name: "Non Operational Expenses", value: sumNonOperationalExpenses },
    ];
  }, [operationalExpenses]);
  return (
    <>
      <DashboardBox gridArea="d">
        <BoxHeader
          title="Operational vs Non-Operational Expenses"
          sideText="+4%"
        />
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={operationalExpenses}
            margin={{
              top: 20,
              right: 20,
              left: -10,
              bottom: 55,
            }}
          >
            <CartesianGrid vertical={false} stroke={palette.white[800]} />
            <XAxis
              dataKey="name"
              tickLine={false}
              style={{ fontSize: "10px", fill: "white" }}
            />
            <YAxis
              yAxisId="left"
              orientation="left"
              tickLine={false}
              axisLine={false}
              style={{ fontSize: "10px", fill: "white" }}
            />
            <Tooltip contentStyle={{ background: 'black' }} />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="Non Operational Expenses"
              stroke={palette.yellow[500]}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="Operational Expenses"
              stroke={palette.aqua[900]}
            />
          </LineChart>
        </ResponsiveContainer>
      </DashboardBox>

      <DashboardBox gridArea="e">
        <BoxHeader title="Operational vs Non-Operational Expenses." sideText="+4%" />
        <FlexBetween mt="0.25rem" gap="1.5rem" pr="1rem">
          <PieChart
            width={110}
            height={100}
            margin={{
              top: 0,
              right: -10,
              left: 10,
              bottom: 0,
            }}
          >
            <Pie
              stroke="none"
              data={pieData}
              innerRadius={18}
              outerRadius={38}
              paddingAngle={2}
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={pieColors[index]} />
              ))}
            </Pie>
          </PieChart>
              {pieData[0].name}:{pieData[0].value}<br></br>
              {pieData[1].name}:{pieData[1].value}
        </FlexBetween>
      </DashboardBox>
      <DashboardBox gridArea="f">
      <BoxHeader title="Product Prices vs Expenses" sideText="+4%" />
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart
            margin={{
              top: 20,
              right: 25,
              bottom: 40,
              left: -10,
            }}
          >
            <CartesianGrid stroke={palette.purple[400]} />
            <XAxis
              type="number"
              dataKey="price"
              name="price"
              axisLine={false}
              tickLine={false}
              style={{ fontSize: "10px",fill:"white" }}
              tickFormatter={(v) => `$${v}`}
            />
            <YAxis
              type="number"
              dataKey="expense"
              name="expense"
              axisLine={false}
              tickLine={false}
              style={{ fontSize: "10px",fill:"white" }}
              tickFormatter={(v) => `$${v}`}
            />
            <ZAxis type="number" range={[20]} />
            <Tooltip formatter={(v) => `$${v}`} />
            <Scatter
              name="Product Expense Ratio"
              data={productExpenseData}
              fill={palette.yellow[300]}
            />
          </ScatterChart>
        </ResponsiveContainer>
      </DashboardBox>
    </>
  )
}

export default Row2